export default __webpack_public_path__ + "static/media/TotalFilesIcon.9d3001fc.svg";